gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
$(window).on('beforeunload', function(){
    $(window).scrollTop(0);
});

$( document ).ready(function() {
    
    $(this).scrollTop(0);
    var imageCount = $('#hero img').length
    var loadedimageCount = '0'
    var imagePercent = '0'
    
    var imgLoad = $('#hero').imagesLoaded()
    .progress( function( instance, image ) {
        var result = image.isLoaded ? 'loaded' : 'broken';
        if(image.isLoaded == true){
            loadedimageCount++
        }
        findimagePercent(imageCount, loadedimageCount)
    });

    function findimagePercent(imageCount, loadedimageCount){
        var bar1 = new ldBar(".ldBar");
        imagePercent = loadedimageCount/ imageCount * 100
        bar1.set(imagePercent);
        return imagePercent
    }

    function setDinamycHeightAttraction(){
        $('.scroll__text').each(function() {
            let $this = $(this)
            let textHeight = $this.height()
            $this.parent().parent().siblings(".scroll__trunk").css('height', textHeight + 110)
        })
    }
    /* construct manually */
    $('body').imagesLoaded('#hero').done( function() {
        setDinamycHeightAttraction()
        killSakura();
        ScrollTrigger.refresh()
        ScrollTrigger.defaults({
            // markers: true,
            start: "center bottom",
            toggleActions: "play play resume resume"
        });      
        let tl = gsap.timeline()
        tl
            .to("#loader", {opacity:0, duration: 1})
            .call(removeElement("#loader"))
            .to("#slasher", { duration: .1, opacity: 1, ease: "circ.out", motionPath:{path: '#path', align: '#path', start: 1, end: 0, alignOrigin: [0.5, 0.5]} })
            .to("#slasher", { duration: .1, opacity: 0 })
            .to(".slash", {opacity: 0, delay: 0})
            .to(".paper--top", {x: -25, y: 5, duration: .1, delay: 0, ease: "slow(0.7, 0.7, false)"}, "paper")
            .to(".paper--bottom", {x: 25, y: -5, duration: .1, delay: 0, ease: "slow(0.7, 0.7, false)"}, "paper")
            .to(".paper--top", {x: -50, y: 150, opacity: 0, delay: 1, rotate: -3, duration: 1, ease: "power2.out"}, "paper2")
            .to(".paper--bottom", {x: 50, y: -150, opacity: 0, delay: 1, rotate: 3, duration: 1, ease: "power2.out"}, "paper2")
            .call(removeElement("#slash"))
            .call()
            .to("body", {onComplete: onCompleteIntro, delay: 0})

            // .from('.hero__image--vendor-left', {opacity: 0, x: -10, ease: "power2.out", duration: .5, delay: .2}, "vendor")
            // .from('.hero__image--vendor-right', {opacity: 0, x: 10, ease: "power2.out", duration: .5, delay: .2}, "vendor")
            // .from('.hero__image--villa', {opacity: 0, x: 10, ease: "power2.out", duration: .5, delay: .2}, "vendor")
            // .from('.hero__image--rigging', {opacity: 0, x: 10, ease: "power2.out", duration: .5, delay: .2}, "vendor")
            // .from('.hero__image--people', {opacity: 0, x: 10, ease: "power2.out", duration: .5, delay: .2}, "vendor")

            .from('.hero__image--ninja-blue', {opacity: 0, y: 100, ease: "back.out(1.7)", duration: .3})
            .from('.hero__image--ninja-yellow', {opacity: 0, y: 100, ease: "back.out(1.7)", duration: .3})
            .from('.hero__image--yukata-girl', {opacity: 0, x: -10, ease: "power2.out", duration: .3})
            .from('.hero__image--minicat-boy', {opacity: 0, scale: .2, x: "14%", y: "5%", ease: "power2.out", duration: .2}, "minicat")
            .from('.hero__image--minicat-girl', {opacity: 0, scale: .2, x: "14%", y: "5%", ease: "power2.out", duration: .2}, "minicat")
            .from('.hero__image--wave', {opacity: 0, x: -10, ease: "power2.out", duration: .2})
            .from('.hero__image--fuji', {opacity: 0, y: 70, ease: "power2.out", duration: .2})
            .from('.hero__image--edokko', {opacity: 0, scale: .2, x: "16%", y: "-185%", ease: "power2.out", duration: .5})
            .from('.hero__image--shuuriken', {opacity: 0, scale: .2, x: "14%", y: "5%", ease: "power2.out", duration: .5})
            .call(callSakuraHero)
            .to('.hero__image--shuuriken', {rotation: 360, transformOrigin:"center center", repeat: -1, duration: 2, ease: Power0.easeNone})
            .to('.hero__image--ninja-yellow', {y: -5, yoyo: true, repeat: -1, duration: .5, ease: Power0.easeNone})
            .to('.hero__image--yukata-girl', {x: -5, yoyo: true, repeat: -1, duration: .5, ease: Power0.easeNone})
            .to('.hero__image--ninja-blue', {y: -15, yoyo: true, repeat: -1, duration: .5, ease: Power0.easeNone})

        
        let hero = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero',
                onLeave: killSakura, //remove sakura when leave hero
                onEnterBack: callSakuraHero, //call sakura when entering hero
            },
            
        })

            
        let fujislider = gsap.timeline({
            scrollTrigger: '#fujislider',
            markers: false,
            start: "top top",
        })
        let fujisliderScroll = gsap.timeline({
            scrollTrigger: '#fujislider-mobile-scroll',
            markers: true,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            fujislider.from(".fujislider-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".fujislider-illustration", {opacity: 0, scale: .8, duration: 1});
            fujisliderScroll.from("#fujislider .mobile-scroll__paper", {height: 0, duration: 1})
        }else{
            fujislider.from(".fujislider-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".fujislider-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#fujislider .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#fujislider .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let edokkocastle = gsap.timeline({
            scrollTrigger: '#edokkocastle',
            markers: false,
            start: "top top",
        })
        let edokkocastleScroll = gsap.timeline({
            scrollTrigger: '#edokkocastle-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            edokkocastle.from(".edokkocastle-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".edokkocastle-illustration", {opacity: 0, scale: .8, duration: 1})
            edokkocastleScroll.from("#edokkocastle .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            edokkocastle.from(".edokkocastle-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".edokkocastle-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#edokkocastle .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#edokkocastle .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let ninjaschool = gsap.timeline({
            scrollTrigger: '#ninjaschool',
            markers: false,
            start: "top top",
        })
        let ninjaschoolScroll = gsap.timeline({
            scrollTrigger: '#ninjaschool-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            ninjaschool.from(".ninjaschool-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".ninjaschool-illustration", {opacity: 0, scale: .8, duration: 1})
            ninjaschoolScroll.from("#ninjaschool .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            ninjaschool.from(".ninjaschool-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".ninjaschool-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#ninjaschool .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#ninjaschool .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let sakuramarket = gsap.timeline({
            scrollTrigger: '#sakuramarket',
            markers: false,
            start: "top top",
        })
        let sakuramarketScroll = gsap.timeline({
            scrollTrigger: '#sakuramarket-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            sakuramarket.from(".sakuramarket-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".sakuramarket-illustration", {opacity: 0, scale: .8, duration: 1})
            sakuramarketScroll.from("#sakuramarket .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            sakuramarket.from(".sakuramarket-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".sakuramarket-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#sakuramarket .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#sakuramarket .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let terakoya = gsap.timeline({
            scrollTrigger: '#terakoya',
            markers: false,
            start: "top top",
        })
        let terakoyaScroll = gsap.timeline({
            scrollTrigger: '#terakoya-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            terakoya.from(".terakoya-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".terakoya-illustration", {opacity: 0, scale: .8, duration: 1})
            terakoyaScroll.from("#terakoya .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            terakoya.from(".terakoya-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".terakoya-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#terakoya .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#terakoya .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let babycorner = gsap.timeline({
            scrollTrigger: '#babycorner',
            markers: false,
            start: "top top",
        })
        let babycornerScroll = gsap.timeline({
            scrollTrigger: '#babycorner-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            babycorner.from(".babycorner-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".babycorner-illustration", {opacity: 0, scale: .8, duration: 1})
            babycornerScroll.from("#babycorner .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            babycorner.from(".babycorner-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".babycorner-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#babycorner .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#babycorner .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let kawaiiphoto = gsap.timeline({
            scrollTrigger: '#kawaiiphoto',
            markers: false,
            start: "top top",
        })
        let kawaiiphotoScroll = gsap.timeline({
            scrollTrigger: '#kawaiiphoto-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            kawaiiphoto.from(".kawaiiphoto-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".kawaiiphoto-illustration", {opacity: 0, scale: .8, duration: 1})
            kawaiiphotoScroll.from("#kawaiiphoto .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            kawaiiphoto.from(".kawaiiphoto-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".kawaiiphoto-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#kawaiiphoto .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#kawaiiphoto .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        let partyroom = gsap.timeline({
            scrollTrigger: '#partyroom',
            markers: false,
            start: "top top",
        })
        let partyroomScroll = gsap.timeline({
            scrollTrigger: '#partyroom-mobile-scroll',
            markers: false,
            start: "center center"
        })
        if (window.innerWidth < 737) {
            partyroom.from(".partyroom-logo", {opacity: 0, scale: .8, duration: .1})
                .from(".partyroom-illustration", {opacity: 0, scale: .8, duration: 1})
            partyroomScroll.from("#partyroom .mobile-scroll__paper", {height: 0, duration: 1}, "+=.5")
        }else{
            partyroom.from(".partyroom-logo", {opacity: 0, scale: .5, duration: 1})
                .from(".partyroom-illustration", {opacity: 0, scale: .5, duration: 1})
                .from("#partyroom .scroll__trunk", {x: 100, duration: 1}, "-=1.5")
                .from("#partyroom .scroll__paper-content", {x: "-100%", opacity: 0, duration: 1}, "-=1.5")
        }

        //function to open mobile menu
        $( "#mobile-menu__trigger, .overlay-menu__each a" ).click(function() {
            $( ".hamburger" ).toggleClass( "is-active" );
            $( "#menu-overlay" ).toggleClass( "open" );
            $( "body" ).toggleClass( "overflow-hidden" )
        })

        //support smooth scrolling for IE11
        if (typeof NodeList.prototype.forEach !== 'function')  {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        //smooth scrolling function when click on anchor
        document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                $('html, body').animate({
                    scrollTop: $(this.getAttribute('href')).offset().top - 60
            }, 1000);
            });
        });

        function callSakuraHero(){
            var sakuratl2 = new gsap.timeline()
        
            var total = 10;
            var container = document.getElementById("hero"),	w = window.innerWidth , h = window.innerHeight;
            var variant = 3;

            for (var i=0; i<total; i++){ 
            var Div = document.createElement('div');
            sakuratl2.set(Div,{attr:{class:'dot dot-' + (Math.floor( Math.random() * variant ) + 1) },x:R(0,w),y:R(-200,-150),z:R(-200,200),top:0});
            container.appendChild(Div);
            animm(Div);
            }
            
            function animm(elm){   
            TweenMax.to(elm,R(6,15),{y:h+100,ease:Linear.easeNone,repeat:-1,delay:-15});
            TweenMax.to(elm,R(4,8),{x:'+=100',rotationZ:R(0,180),repeat:-1,yoyo:true,ease:Sine.easeInOut});
            TweenMax.to(elm,R(2,8),{rotationX:R(0,360),rotationY:R(0,360),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
            };
        
            function R(min,max) {return min+Math.random()*(max-min)};
            
        }
        
        function killSakura(){
            gsap.killTweensOf(".dot")
            $('.dot').remove()
        }
    });
});

//function to remove selected element
function removeElement(element) {
    if (typeof(element) === "string") {
      element = document.querySelector(element);
    }
    return function() {
      element.parentNode.removeChild(element);
    };
  }

//function to remove overflow-hidden on body after intro complete
function onCompleteIntro() {
    document.body.classList.remove('overflow-hidden');
}


//function to add isFixed class on header after scrolled pass 80px
$(window).scroll(function () {

     if ($(window).scrollTop() >= 80) {
     $('header').addClass('isFixed');
     } else {
     $('header').removeClass('isFixed');
     }
});

function previewImage(el){
    var modal = document.getElementById("modal-iamge");

    // Get the image and insert it inside the modal - use its "alt" text as a caption
    var img = this.el
    var modalImg = document.getElementById("preview-image");
    img.onclick = function(){
    modal.style.display = "block";
    modalImg.src = this.src;
    }

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    span.onclick = function() { 
    modal.style.display = "none";
    }
}

